import React, { useEffect, useState } from 'react'
import logo from "./../images/logo.png"
import { Menu } from 'lucide-react'

const navigation = [
    { name: 'Home', href: '/#home' },
    { name: 'About', href: '/#about' },
    { name: 'Services', href: '/#services' },
    { name: 'Why Choose Us', href: '/#whyus' },
    { name: 'FAQs', href: '/faqs' },
    { name: 'Careers', href: '/careers' }
]

function Navbar() {
    const [scrolled, setScrolled] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        }
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [])

    return (
        <nav className={`navbar navbar-expand-lg fixed-top py-3  border-0 ${scrolled ? "bg-white" : "bg-transparent"}`} data-navbar-on-scroll="dark">
            <div className="container">
                <a className="navbar-brand" href="/">
                    <img src={logo} height="40" alt="logo" />
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <Menu className={scrolled ? 'text-dark' : 'text-white'} />
                </button>
                <div className="collapse navbar-collapse mt-4 mt-lg-0" id="navbarSupportedContent">
                    <ul className="navbar-nav ms-auto pt-2 pt-lg-0 font-base align-items-center">
                        {navigation.map((item, index) => (
                            <li className="nav-item" key={index}><a className={`nav-link px-3 ${scrolled ? 'text-dark' : 'text-white'}`} href={item.href} style={{fontSize: 13}}>{item.name}</a></li>
                        ))}
                    </ul>
                    <div className="d-none d-lg-block">
                        <a className="btn py-2 px-3 ms-2" href="/waiting" style={{backgroundColor: '#D1B000', color: '#fff', fontSize: 13}}>
                            WaitList
                        </a>
                    </div>
                    <div className="d-lg-none text-center mt-3">
                        <a className="btn py-2 px-3" href="/waiting" style={{backgroundColor: '#D1B000', color: '#fff', fontSize: 13}}>
                            WaitList
                        </a>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Navbar
